export default __webpack_public_path__ + "static/media/hint-modal-icon.756d95ed.svg";